import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PalantirTextComponent } from './palantir-text.component';


@NgModule({
  declarations: [
    PalantirTextComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [PalantirTextComponent]
})
export class PalantirTextModule {}
